import styled from 'styled-components';

export const ContainerControls = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
`;

export const ControlGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Label = styled.label`
    font-weight: 500;
    color: #333;
`;

export const SelectInput = styled.select`
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
    cursor: pointer;
    min-width: 80px;

    &:focus {
        outline: none;
        border-color: #007bff;
    }
`;

export const SelectedInfo = styled.div`
    padding: 8px 16px;
    background-color: #e7f3ff;
    border: 1px solid #b3d9ff;
    border-radius: 4px;
    color: #0066cc;
    font-size: 14px;
`;

export const StyledCard = styled.div`
    .check-pole {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;


